import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminProjectTable from "../../../components/admin/project/AdminProjectTable";
import AdminProjectRequestTable from "../../../components/admin/project/AdminProjectRequestTable";

//어드민 프로젝트 메인 페이지
const AdminProjectMainPage: React.FC = () => {
    return (
        <AdminLayout>
            {/*어드민 프로젝트 테이블*/}
            <AdminProjectTable/>
            {/*어드민 프로젝트 추가 요청 테이블*/}
            <AdminProjectRequestTable/>
        </AdminLayout>
    )
}
export default AdminProjectMainPage;